module.exports = __webpack_public_path__ + "static/media/S1N8-2.022c476c.svg";